$(document).ready(function() {

	$('.newsletter__btn a').on('click', event => {
		event.preventDefault();

		if (typeof window.dojoRequire === 'undefined') return console.log('MailChimp not loaded');

		document.cookie = 'MCPopupClosed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
		document.cookie = 'MCPopupSubscribed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';

		window.dojoRequire(["mojo/signup-forms/Loader"], function(L) {
			L.start({
				"baseUrl":"mc.us13.list-manage.com",
				"uuid":"80a77b61e2895b7b37c71bfc2",
				"lid":"5e54526f77",
				"uniqueMethods":true
			});
		});

		document.cookie = 'MCPopupClosed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
		document.cookie = 'MCPopupSubscribed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
	});

});